module.exports = __webpack_public_path__ + "static/media/통합본.66c1a02c.pdf";